
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {AUTH_CHANGE_PIN} from "@/store/action-types";
import {ChangePasswordPayload} from "@/types/payload";
import {TranslateResult} from "vue-i18n";
import {setSetting} from "@/services/settings";
import i18n from "@/plugins/i18n";

@Component({})
export default class ChangePinPage extends Vue {
  private isFormValid: boolean = false
  private isSaveInProgress: boolean = false
  private password: string | null = null
  private passwordRules: Array<(v: string) => string | boolean | TranslateResult> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => (v && v.length > 3)  || i18n.t('validation.passwordValidationText').toString(),
    (v: string) => {
      const pattern = /^[a-zA-Z0-9]*$/

      return pattern.test(v) || i18n.t('validation.valueIsRequired').toString()
    },
  ]
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''

  @Action(AUTH_CHANGE_PIN) saveNewPin!: ({ (payload: ChangePasswordPayload): Promise<void> })

  generateCodeClick () {
    this.password = Math.floor(1000 + Math.random() * 9000).toString()
  }

  async onSubmitButtonClick(): Promise<void> {
    const payload: ChangePasswordPayload = {
      password: this.password!.toString(),
      isForced: true
    }
    try {
      this.isSaveInProgress = true

      await this.saveNewPin(payload)

      setSetting('boarder.force_pin_change', false)

      this.$router.push({name: 'Dashboard'})
    } catch (e) {
      this.snackBar = true
      this.snackBarColor="error"
      this.snackBarMessage=this.$t('changePinPage.saveDataMessage').toString()
    } finally {
      this.isSaveInProgress = false
      this.snackBar = true
      this.snackBarColor="success"
      this.snackBarMessage=this.$t('changePinPage.saved').toString()
    }
  }
}
